import { datadogRum } from '@datadog/browser-rum';
import { DefaultPrivacyLevel } from '@datadog/browser-core';
import { getAppConfig } from 'app/getConfig';
import { APP_VERSION } from 'config/appVersion';

/**
 * Called at app entry (app/index.tsx), before the React tree mounts and data
 * fetching starts, so RUM captures timing from navigationStart. Compliance is
 * preserved: events are buffered until CookieConsent grants tracking consent.
 * The `datadog-rum` GrowthBook flag cannot be read here (features are not
 * loaded yet); it acts as a kill switch in CookieConsent, which withholds the
 * consent grant while the flag is off, keeping the SDK buffered and silent.
 */
export const initializeDatadogRUM = () => {
  const {
    NODE_ENV,
    DATADOG_SURVEY_UI_CLIENT_TOKEN,
    DATADOG_SURVEY_UI_RUM_APPLICATION_ID,
    DATADOG_SURVEY_UI_RUM_DEFAULT_PRIVACY_LEVEL,
    DATADOG_SURVEY_UI_RUM_SESSION_REPLAY_SAMPLE_RATE,
    DATADOG_SURVEY_UI_RUM_SESSION_SAMPLE_RATE,
    ADMIN_READ_API_CLIENT_URL,
    ADMIN_WRITE_API_CLIENT_URL,
  } = getAppConfig();

  if (!DATADOG_SURVEY_UI_RUM_APPLICATION_ID || !DATADOG_SURVEY_UI_CLIENT_TOKEN) {
    return;
  }

  datadogRum.init({
    applicationId: DATADOG_SURVEY_UI_RUM_APPLICATION_ID,
    clientToken: DATADOG_SURVEY_UI_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    service: 'survey-ui',
    env: NODE_ENV,
    version: APP_VERSION,
    defaultPrivacyLevel: DATADOG_SURVEY_UI_RUM_DEFAULT_PRIVACY_LEVEL as DefaultPrivacyLevel,
    sessionReplaySampleRate: parseInt(DATADOG_SURVEY_UI_RUM_SESSION_REPLAY_SAMPLE_RATE),
    sessionSampleRate: parseInt(DATADOG_SURVEY_UI_RUM_SESSION_SAMPLE_RATE),
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [ADMIN_READ_API_CLIENT_URL, ADMIN_WRITE_API_CLIENT_URL],
    trackingConsent: 'not-granted',
  });

  datadogRum.startSessionReplayRecording();
};
